const colors = {
  HYVINVOINT: {main: '#00857C', light: '#eeeeee', dark: '#003D34', contrastText: "#fff"},
  MTLH: {main: '#037D3E', light: '#eeeeee', dark: '#062D16', contrastText: "#fff"},
  PHT: {main: '#017ABC', light: '#eeeeee', dark: '#002B42', contrastText: "#fff"},
  PHTPERHE: {main: '#017ABC', light: '#eeeeee', dark: '#002B42', contrastText: "#fff"},
  NASYLOMAT: {main: '#A03288', light: '#eeeeee', dark: '#001724', contrastText: "#fff"},
  SOLARISLOM: {main: '#AD0000', light: '#eeeeee', dark: '#290000', contrastText: "#fff"},
  SEMESTER: {main: '#0666B3', light: '#eeeeee', dark: '#011423', contrastText: "#fff"},
};

export default function OrganizationTheme({theme, organization}) {
  return ({
    logo: `${process.env.PUBLIC_URL}/images/logo_${organization}.png`,
    ...theme,
    palette: {
      ...theme.palette,
      primary: {
        ...theme.palette.primary,
        ...colors[organization]
      }
    }
  });
}
